module.exports = __webpack_public_path__ + "static/table2768-52f4008529fc5cca5f7f4e74fd53063f.png";